/** Tiny dev-only logger.
 * Silent in production so we don't ship debug noise to end users,
 * but keeps diagnostic warnings during local development. */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};
